import React, { useContext, useEffect, useState } from 'react';

import { PagesContext } from '../store/PagesContext';

import UList from 'components/Lists/UList';

import Columns from '../components/Columns';
import AMTPopup from '../components/popups/AMTPopup';
import SaleDayPopup from '../components/popups/SaleDayPopup';
import SpreadPopup from '../components/popups/SpreadPopup';

const IsoE = () => {
  const [isSaleDayPopupOpen, setIsSaleDayPopupOpen] = useState(false);
  const openSaleDayPopup = () => setIsSaleDayPopupOpen(true);

  const [isAMTPopupOpen, setIsAMTPopupOpen] = useState(false);
  const openAMTPopup = () => setIsAMTPopupOpen(true);

  const [isSpreadPopupOpen, setIsSpreadPopupOpen] = useState(false);
  const openSpreadPopup = () => setIsSpreadPopupOpen(true);

  const [, setLastPage] = useContext(PagesContext);

  useEffect(() => setLastPage('isoC'), []);

  const sideContent = (
    <>
      If you sell your shares in the same calendar year as exercising (includes{' '}
      <span className='color-black c-pointer' onClick={openSaleDayPopup}>
        same-day sales/cashless exercise
      </span>{' '}
      ) then:
    </>
  );

  return (
    <>
      <Columns sideContent={sideContent} theme='blue'>
        <UList theme='blue'>
          <li>
            You do not need to adjust your income to determine your{' '}
            <span className='color-blue c-pointer' onClick={openAMTPopup}>
              AMT (alternative minimum tax)
            </span>
            .
          </li>
          <li>
            Instead, you will pay income tax on the{' '}
            <span className='color-blue c-pointer' onClick={openSpreadPopup}>
              spread
            </span>{' '}
            for the year of sale.
          </li>
          <li>In addition, you will be subject to the capital gains tax rates on the increase after exercise.</li>
          <li>
            However, if the sale price is below the FMV (fair market value) at exercise, the increase above strike price will be ordinary
            income
          </li>
          <li>
            Further, if the sale price is below the strike price, the decrease below the strike price will be STCL (short term capital loss)
          </li>
          <li>You may also be required to pay estimated taxes on a quarterly basis</li>
        </UList>
      </Columns>

      <SaleDayPopup isPopupOpen={isSaleDayPopupOpen} setIsPopupOpen={setIsSaleDayPopupOpen} />
      <AMTPopup isPopupOpen={isAMTPopupOpen} setIsPopupOpen={setIsAMTPopupOpen} />
      <SpreadPopup isPopupOpen={isSpreadPopupOpen} setIsPopupOpen={setIsSpreadPopupOpen} />
    </>
  );
};

export default IsoE;
